// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.motivation-container {
    width: 90%;
    max-width: 800px;
    margin: 50px auto;
    font-family: 'Rubik', sans-serif;
  }
  
  .motivation-box {
    background-color: #A5D6A7;
    border-radius: 20px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    padding: 30px;
  }
  
  .motivation-header {
    text-align: center !important;
    margin-bottom: 25px;
    justify-content: center;
  }
  
  .motivation-header h2 {
    font-weight: 700;
    font-size: 32px;
    color: #333;
    margin: 0;
  }
  
  .motivation-alert {
    margin-bottom: 25px;
    border-radius: 8px;
    border: none;
  }
  
  .motivation-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
    margin-bottom: -1px;
  }
  
  .form-textarea {
    min-height: 200px;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 10px;
    font-family: 'Rubik', sans-serif;
    font-size: 15px;
    resize: vertical;
    transition: all 0.3s ease;
    background-color: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  }
  
  .form-textarea:focus {
    outline: none;
    border-color: #388E3C;
    box-shadow: 0 0 0 3px rgba(56, 142, 60, 0.2);
  }
  
  .form-checkbox-group {
    display: flex;
    align-items: center;
  }
  
  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    color: #333;
    font-weight: 500;
  }
  
  .checkbox-input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
  
  .checkbox-custom {
    position: relative;
    height: 20px;
    width: 20px;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    transition: all 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  .checkbox-input:checked ~ .checkbox-custom {
    background-color: #388E3C;
    border-color: #388E3C;
  }
  
  .checkbox-input:checked ~ .checkbox-custom::after {
    content: "";
    position: absolute;
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  
  .submit-button {
    padding: 10px 20px;
    background-color: #004D40;
    color: white;
    border: none;
    border-radius: 14px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 222px;
    height: 55px;
    margin: 10px auto 0;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    font-family: 'Rubik', sans-serif;
  }
  
  .submit-button:hover {
    background-color: #2E7D32;
    transform: translateY(-1px);
  }
  
  .submit-button:active {
    transform: translateY(0);
  }
  
  .submit-button:disabled {
    background-color: #81C784;
    cursor: not-allowed;
    transform: none;
  }
  
  .spin-icon {
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  @media (max-width: 768px) {
    .motivation-container {
      width: 95%;
      margin: 30px auto;
    }
    
    .motivation-box {
      padding: 20px;
    }
    
    .motivation-header h2 {
      font-size: 28px;
    }
    
    .form-textarea {
      min-height: 150px;
    }
    
    .submit-button {
      width: 100%;
    }
  }

  .success-message-container {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    pointer-events: none;
  }
  
.success-message21 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message21 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}
  
  @keyframes fadeInOut {
    0% { opacity: 0; transform: translateY(-20px); }
    10% { opacity: 1; transform: translateY(0); }
    90% { opacity: 1; transform: translateY(0); }
    100% { opacity: 0; transform: translateY(-20px); }
  }
  
  .motivation-alert {
    margin-bottom: 25px;
  }

  .submit-buttonn {
    padding: 10px 20px;
    background-color: #004D40;
    color: white;
    border: none;
    border-radius: 14px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 222px;
    height: 55px;
    margin: 10px auto 0;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    font-family: 'Rubik', sans-serif;
  }
  
  .submit-buttonn:hover {
    background-color: #2E7D32;
    transform: translateY(-1px);
  }
  
  .submit-buttonn:active {
    transform: translateY(0);
  }
  
  .submit-buttonn:disabled {
    background-color: #81C784;
    cursor: not-allowed;
    transform: none;
  }

  .motivation-headerk {
    text-align: center !important;
    margin-bottom: 25px;
    justify-content: center;
  }`, "",{"version":3,"sources":["webpack://./src/styles/CreateMotivationPage.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;EACf;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;IACvB,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,wCAAwC;IACxC,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,OAAO,uBAAuB,EAAE;IAChC,KAAK,yBAAyB,EAAE;EAClC;;EAEA;IACE;MACE,UAAU;MACV,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,oBAAoB;EACtB;;AAEF;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;EAEE;IACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;IAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;IAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;IAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACnD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,wCAAwC;IACxC,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;EACzB","sourcesContent":[".motivation-container {\n    width: 90%;\n    max-width: 800px;\n    margin: 50px auto;\n    font-family: 'Rubik', sans-serif;\n  }\n  \n  .motivation-box {\n    background-color: #A5D6A7;\n    border-radius: 20px;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n    padding: 30px;\n  }\n  \n  .motivation-header {\n    text-align: center !important;\n    margin-bottom: 25px;\n    justify-content: center;\n  }\n  \n  .motivation-header h2 {\n    font-weight: 700;\n    font-size: 32px;\n    color: #333;\n    margin: 0;\n  }\n  \n  .motivation-alert {\n    margin-bottom: 25px;\n    border-radius: 8px;\n    border: none;\n  }\n  \n  .motivation-form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .form-group {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: -1px;\n  }\n  \n  .form-textarea {\n    min-height: 200px;\n    padding: 15px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    font-family: 'Rubik', sans-serif;\n    font-size: 15px;\n    resize: vertical;\n    transition: all 0.3s ease;\n    background-color: white;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  }\n  \n  .form-textarea:focus {\n    outline: none;\n    border-color: #388E3C;\n    box-shadow: 0 0 0 3px rgba(56, 142, 60, 0.2);\n  }\n  \n  .form-checkbox-group {\n    display: flex;\n    align-items: center;\n  }\n  \n  .checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n    user-select: none;\n    color: #333;\n    font-weight: 500;\n  }\n  \n  .checkbox-input {\n    position: absolute;\n    opacity: 0;\n    height: 0;\n    width: 0;\n  }\n  \n  .checkbox-custom {\n    position: relative;\n    height: 20px;\n    width: 20px;\n    background-color: white;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    transition: all 0.3s ease;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  }\n  \n  .checkbox-input:checked ~ .checkbox-custom {\n    background-color: #388E3C;\n    border-color: #388E3C;\n  }\n  \n  .checkbox-input:checked ~ .checkbox-custom::after {\n    content: \"\";\n    position: absolute;\n    left: 6px;\n    top: 2px;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n  }\n  \n  .submit-button {\n    padding: 10px 20px;\n    background-color: #004D40;\n    color: white;\n    border: none;\n    border-radius: 14px;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    width: 222px;\n    height: 55px;\n    margin: 10px auto 0;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    font-family: 'Rubik', sans-serif;\n  }\n  \n  .submit-button:hover {\n    background-color: #2E7D32;\n    transform: translateY(-1px);\n  }\n  \n  .submit-button:active {\n    transform: translateY(0);\n  }\n  \n  .submit-button:disabled {\n    background-color: #81C784;\n    cursor: not-allowed;\n    transform: none;\n  }\n  \n  .spin-icon {\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n  }\n  \n  @media (max-width: 768px) {\n    .motivation-container {\n      width: 95%;\n      margin: 30px auto;\n    }\n    \n    .motivation-box {\n      padding: 20px;\n    }\n    \n    .motivation-header h2 {\n      font-size: 28px;\n    }\n    \n    .form-textarea {\n      min-height: 150px;\n    }\n    \n    .submit-button {\n      width: 100%;\n    }\n  }\n\n  .success-message-container {\n    position: fixed;\n    top: 70px;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    pointer-events: none;\n  }\n  \n.success-message21 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message21 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n  \n  @keyframes fadeInOut {\n    0% { opacity: 0; transform: translateY(-20px); }\n    10% { opacity: 1; transform: translateY(0); }\n    90% { opacity: 1; transform: translateY(0); }\n    100% { opacity: 0; transform: translateY(-20px); }\n  }\n  \n  .motivation-alert {\n    margin-bottom: 25px;\n  }\n\n  .submit-buttonn {\n    padding: 10px 20px;\n    background-color: #004D40;\n    color: white;\n    border: none;\n    border-radius: 14px;\n    font-size: 18px;\n    font-weight: bold;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    width: 222px;\n    height: 55px;\n    margin: 10px auto 0;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    font-family: 'Rubik', sans-serif;\n  }\n  \n  .submit-buttonn:hover {\n    background-color: #2E7D32;\n    transform: translateY(-1px);\n  }\n  \n  .submit-buttonn:active {\n    transform: translateY(0);\n  }\n  \n  .submit-buttonn:disabled {\n    background-color: #81C784;\n    cursor: not-allowed;\n    transform: none;\n  }\n\n  .motivation-headerk {\n    text-align: center !important;\n    margin-bottom: 25px;\n    justify-content: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
